import FileType from "./fileType";
import MessageType from "./messageType";
import moment from 'moment';
// import * as ContactUtils from './contactUtils';
import { getFormChatFlow } from './stepUtils';


export const ChatMessageType = {

    TEXT: 'message_text',
    QUOTED_TEXT: 'message_quoted',
    DELETED_TEXT: 'message_deleted',

    FORM: 'message_form',

    FILE: 'message_file',
    FILE_IMAGE: 'message_image',
    FILE_VIDEO: 'message_video',

    LOCATION: 'message_location',

    INFO: 'info_message_UNUSED',
    INFO_MEMBER_ADDED: 'chat_member_added',
    INFO_MEMBER_REMOVED: 'chat_member_removed',
    INFO_TOPIC_CHANGED: 'topic_changed',
    INFO_CHILD_ROOM_CREATED: 'child_room_created',

    PING: 'ping',

    CALL: 'message_Aform',
    VIDEO_CALL: 'message_Aform'
}

const FileTypeMapping = {

    [ChatMessageType.FILE]: FileType.OTHER,
    [ChatMessageType.FILE_IMAGE]: FileType.IMAGE,
    [ChatMessageType.FILE_VIDEO]: FileType.VIDEO
}

export function getLastMessage(messages, currentUser, data, myContacts) {
    messages.sort(function (a, b) {
        return moment(b.createdAt).format('X') - moment(a.createdAt).format('X')
    });
    return getMessageText(messages[0], currentUser, data, myContacts);
}

export function getMessageText(message, currentUser, data, contacts) {
    if (!message) {
        return 'Conversation Started';
    }
    let senderName = 'You sent '

    if (message.sender && (message.sender != currentUser.mobileNumber)) { 
        const senderUser = data.rawData && data.rawData.members && data.rawData.members.find(member => member.userId == message.sender)
        senderName = senderUser ? `${(senderUser.nickname)} sent `: `${message.sender} sent `;
    }

   
    const { messageBody } = message;

    const messageType = getMessageType(message);
    switch (messageType) {
        case MessageType.QUOTED_TEXT:
        case MessageType.DELETED_TEXT:
        case MessageType.TEXT:
            return senderName + messageBody.payload.message;

        case MessageType.CALL:
        case MessageType.FORM: {
            if(messageBody && messageBody.payload && messageBody.payload.form && messageBody.payload.form.formId){
                const currentChatFlow = getFormChatFlow(messageBody.payload.form.formId);
                if (currentChatFlow && currentChatFlow.name) return senderName + currentChatFlow.name
            }


            return 'Form shared';
        };

        case MessageType.INFO: {

            // let { eventContent } = this;
            // let infoType = eventContent.type;

            // let senderId = this.senderId;
            // let sender = this.context.users.getUser( senderId );
            // let senderName = sender ? sender.nameOrMobileNumber : senderId;
            let isSender = message.sender === currentUser.mobileNumber;
            let inforSenderName;
            let user;
            if (isSender) {
                inforSenderName = "You";
            } else {
                const actionUser = data.rawData && data.rawData.members && data.rawData.members.find(member => member.userId == message.sender)
                // inforSenderName = senderUser ? `${(senderUser.nickname)}`: `${message.sender}`;
                // const actionUser = ContactUtils.getContactFromContactList(message.sender);
                inforSenderName = actionUser ? actionUser.nickname : message.sender;
            }

        

            const memberName = message.messageBody?.payload?.name;
            const memberNumber = message.messageBody?.payload?.mobileNumber;

            switch (message.messageBody.type) {

                case ChatMessageType.INFO_MEMBER_ADDED:
                    // user = ContactUtils.getContactFromContactList(memberNumber);
                    user = data.rawData && data.rawData.members && data.rawData.members.find(member => member.userId == memberNumber)
                    // return `${inforSenderName} added ${user ? (user.firstName + " " + user.lastName) : (memberName || memberNumber)}`;
                    return `${inforSenderName} added ${user ? (user.nickname) : (memberName || memberNumber)}`;

                case ChatMessageType.INFO_MEMBER_REMOVED:
                    // user = ContactUtils.getContactFromContactList(memberNumber);
                    user = data.rawData && data.rawData.members && data.rawData.members.find(member => member.userId == memberNumber)
                    // change message if removed self
                    if (message.sender == memberNumber) {
                        // inforSenderName = isSender ? inforSenderName : (user ? (user.firstName + " " + user.lastName) : (memberName || memberNumber));
                        inforSenderName = isSender ? inforSenderName : (user ? (user.nickname) : (memberName || memberNumber));
                        return `${inforSenderName} left conversation`;
                    }
                    //return `${inforSenderName} removed ${user ? (user.nickname + " " + user.lastName) : (memberName || memberNumber)}`;
                    return `${inforSenderName} removed ${user ? (user.nickname) : (memberName || memberNumber)}`;

                case ChatMessageType.INFO_TOPIC_CHANGED:
                    return `${inforSenderName} changed the topic to ${message.messageBody.payload.newTopic}`;
            }

            return 'Info message';

        };

        case MessageType.FILE: {


            switch (messageType) {

                case FileType.IMAGE: return 'Image shared';
                case FileType.VIDEO: return 'Video shared';
                case FileType.AUDIO: return 'Audio shared';
            }

            return senderName + ' File';


        };

        case MessageType.LOCATION: {

            // todo: maybe add address or something
            return senderName + ' Location';
        };
    }
}

export function getMessageType(message) {
    switch (message.messageBody.type) {
        case ChatMessageType.CALL:
            return MessageType.CALL;

        case ChatMessageType.PING:
            return MessageType.PING;

        case ChatMessageType.TEXT:
            return MessageType.TEXT;

        case ChatMessageType.QUOTED_TEXT:
            return MessageType.QUOTED_TEXT;

        case ChatMessageType.DELETED_TEXT:
            return MessageType.DELETED_TEXT;

        case ChatMessageType.FORM:
            return MessageType.FORM;

        case ChatMessageType.INFO_MEMBER_ADDED:
        case ChatMessageType.INFO_MEMBER_REMOVED:
        case ChatMessageType.INFO_TOPIC_CHANGED:
        case ChatMessageType.INFO_CHILD_ROOM_CREATED: {
            return MessageType.INFO;
        }

        case ChatMessageType.FILE:
        case ChatMessageType.FILE_IMAGE:
        case ChatMessageType.FILE_VIDEO:
            return MessageType.FILE;

        case ChatMessageType.LOCATION:
            return MessageType.LOCATION;
    }
}

export const getStatusFromBorderColor = (color) => {
    if (!color?.startsWith("#")) {
        color = `#${color}`
    }
    color = color?.toLowerCase();
    if (["#red", "#ec7a50", "#e55b1f", "#f05b2c", "#e84545", "#fa3260", "#f15b2a"].includes(color)) {
        return { class: 'not_approved', text: "NOT APPROVED" }
    } else if (["#yellow", "#f6c933", "#e79960", "#f49c2a", "#e7ae47", "#f6cc3f", "#ff9924", "#f4b342", "#eec331", "#f4cf64"].includes(color)) {
        return { class: 'pending', text: "PENDING APPROVAL" }
    } else if (["#green", "#b9db4d", "#8bc53f", "#8dc63f", "#78af52", "#8ec93d", "#9dffaf", "#80c12c", "#8dc348", "#f7ca34", "#a6ce39", "#0fb4dc"].includes(color)) {
        return { class: 'approved', text: "APPROVED" }
    } else {
        return { class: 'started', text: "STARTED" }
    }
}